import React from 'react';
import { SignIn } from '@clerk/clerk-react';

export default function SignInPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white mb-2">
            🛡️ FTD DRPS Manager
          </h1>
          <p className="text-slate-400">
            DRPS Manager
          </p>
        </div>
        
        <SignIn 
          routing="path" 
          path="/sign-in"
          afterSignInUrl="/"
          appearance={{
            elements: {
              rootBox: "w-full",
              card: "bg-white shadow-2xl rounded-lg",
              headerTitle: "text-slate-900 text-2xl font-bold",
              headerSubtitle: "text-slate-600",
              socialButtonsBlockButton: "bg-white border-2 border-slate-300 text-slate-700 hover:bg-slate-50 hover:border-slate-400",
              socialButtonsBlockButtonText: "text-slate-700 font-medium",
              formButtonPrimary: "bg-cyan-600 hover:bg-cyan-700 text-white font-medium shadow-md",
              formFieldLabel: "text-slate-700 font-medium",
              formFieldInput: "bg-white border-2 border-slate-300 text-slate-900 placeholder:text-slate-400 focus:border-cyan-500 focus:ring-cyan-500",
              formFieldInputShowPasswordButton: "text-slate-600 hover:text-slate-900",
              footerActionLink: "text-cyan-600 hover:text-cyan-700 font-medium",
              footerActionText: "text-slate-600",
              identityPreviewText: "text-slate-700",
              identityPreviewEditButton: "text-cyan-600 hover:text-cyan-700",
              formResendCodeLink: "text-cyan-600 hover:text-cyan-700",
              otpCodeFieldInput: "border-2 border-slate-300 text-slate-900"
            }
          }}
        />
        
        <div className="mt-6 text-center">
          <p className="text-slate-400 text-sm">
            Contact your administrator for account access
          </p>
        </div>
      </div>
    </div>
  );
}